import script from "./CopilotChatPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopilotChatPanel.vue?vue&type=script&setup=true&lang=ts"

import "./CopilotChatPanel.vue?vue&type=style&index=0&id=5ac5304e&lang=css"

const __exports__ = script;

export default __exports__